
export const populateNumberOfOrdersChartData = (numberOfOrders, newData) => {
    numberOfOrders.value = newData?.count || 0
}
